import { render } from "./ReportsOverview.vue?vue&type=template&id=278509b4&ts=true"
import script from "./ReportsOverview.vue?vue&type=script&lang=ts"
export * from "./ReportsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__